/* global Drupal */
import $ from 'jquery';

let behaviors;
let documentIsReady = false;

/**
 * Allows a Drupal behavior to be added from an AMD-style module. The behavior
 * will be executed when:
 * - As soon as the DOM is ready, if the DOM is not ready when the behavior is
 *   added, just like a regular Drupal behavior.
 * - Immediately upon adding, if the DOM is ready (which may happen since
 *   AMD-style modules are loaded asynchronously).
 * - When Drupal.attachBehaviors is executed.
 */
Drupal.behavior = function addDrupalBehavior(fn) {
  if (!behaviors) {
    behaviors = $.Callbacks();
    documentIsReady = false;

    $(document).ready(() => {
      documentIsReady = true;
      behaviors.fire(document);

      // Now that we know the document is ready, add ourselves to Drupal's
      // behavior handling.
      window.Drupal.behaviors.DrupalAMD = function DrupalAMD(context) {
        behaviors.fire(context);
      };
    });
  }

  // Note: we can't use the 'memory' option of jQuery.Callbacks, because we
  // need control over the argument.
  if (documentIsReady) {
    fn(document);
  }

  behaviors.add(fn);
  return this;
};

export default Drupal;
